import { Injectable, Inject } from '@angular/core';
import { Branch } from '../models/missingdata.model';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BranchService {

  private Url: string;
  private missingBranches: BehaviorSubject<Branch[]>;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.Url = baseUrl;
    this.missingBranches = new BehaviorSubject<Branch[]>(JSON.parse(localStorage.getItem('missingBranches')));
  }

  public get missingBranchesList(): Branch[] {
    return this.missingBranches.value;
  }

  setBranches(branches: Branch[]) {
    localStorage.setItem('missingBranches', JSON.stringify(branches));
  }

  getBranches() {
    return this.http.get<Branch[]>(this.Url + 'api/branches/')
  }

  saveBranches(branches: Branch[]) {
    return this.http.post(this.Url + 'api/branches/', branches)
  }

  updateBranch(branch: Branch) {
    return this.http.patch(this.Url + 'api/branches/', branch)
  }

}
